var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2073",
    "data-name": "Rectangle 2073",
    width: 161.128,
    height: 172.923,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2599",
    "data-name": "Groupe 2599",
    transform: "translate(-832 -275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 128,
    cy: 128,
    r: 128,
    transform: "translate(832 275)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2383",
    "data-name": "Groupe 2383",
    transform: "translate(892.995 316.42)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2922",
    "data-name": "Trac\\xE9 2922",
    d: "M12.656,62.818H25.909a3.266,3.266,0,0,0,3.27-3.27V45.98a26.26,26.26,0,0,1,52.52,0V59.549a3.256,3.256,0,0,0,3.27,3.27H98.2a3.253,3.253,0,0,0,3.206-3.27V45.98a44.609,44.609,0,0,0-1.09-9.919A45.974,45.974,0,0,0,9.45,45.98V59.549a3.263,3.263,0,0,0,3.206,3.27",
    transform: "translate(5.477 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2923",
    "data-name": "Trac\\xE9 2923",
    d: "M108.688,43.937H13.142A13.128,13.128,0,0,0,0,57.063v58.822a13.142,13.142,0,0,0,13.142,13.142H88.549A41.143,41.143,0,0,1,121.83,71.721V57.063a13.138,13.138,0,0,0-13.142-13.126m-40.1,44.922v16.1a7.669,7.669,0,1,1-15.337,0v-16.1a15.9,15.9,0,0,1-.569-27.547h.016a15.9,15.9,0,0,1,16.443,0h.016a15.9,15.9,0,0,1-.569,27.547",
    transform: "translate(0 25.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2924",
    "data-name": "Trac\\xE9 2924",
    d: "M127.573,100.206a34.837,34.837,0,1,1-39.3-34.544,34.406,34.406,0,0,1,4.454-.284,34.879,34.879,0,0,1,34.845,34.829",
    transform: "translate(33.555 37.888)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2925",
    "data-name": "Trac\\xE9 2925",
    d: "M87.541,115.186a2.567,2.567,0,1,1,0-5.133,15.175,15.175,0,1,0,0-30.349,14.953,14.953,0,0,0-1.935.123A15.2,15.2,0,0,0,72.367,94.878a2.567,2.567,0,0,1-5.133,0,20.311,20.311,0,1,1,20.307,20.308",
    transform: "translate(38.965 43.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2926",
    "data-name": "Trac\\xE9 2926",
    d: "M76.639,85.474l-2.758,1.914a2.586,2.586,0,0,1-3.6-.651L68.37,83.978a2.586,2.586,0,1,0-4.251,2.947l4.862,7.008a2.586,2.586,0,0,0,3.6.651l7.008-4.862a2.586,2.586,0,0,0-2.949-4.249",
    transform: "translate(36.892 48.023)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.c8a5618a78c79a0797ec75e70e12e03d.svg";
export { ForwardRef as ReactComponent };